import React from "react";
import Navbar from "../global/Navbar";
import EventCard from "../components/Events/EventCard";
import { events } from "../demodata/Event";


const Events = () => {
 
  return (
    <div className="w-full flex flex-col justify-center items-center bg-[#101e2b]">
      <Navbar />
      <div className="container flex flex-col gap-4 px-4 lg:px-0 mb-[5rem]">
        <h2 className="text-[#22BEFF] text-3xl font-bold mt-[2rem] uppercase text-center border-b border-[#22BEFF33]">
          ইভেন্ট’স
        </h2>
        <div className="w-full grid lg:grid-cols-3 sm:grid-cols-2 grid-cols-1 gap-10 mt-[3rem]">

          {events.map((event,index)=>(
            <EventCard key={index} event={event}/>
          ))}

        </div>
      </div>
    </div>
  );
};

export default Events;
